import { render, staticRenderFns } from "./CreateProcess.vue?vue&type=template&id=234a4dce&"
import script from "./CreateProcess.vue?vue&type=script&lang=js&"
export * from "./CreateProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports